import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { combineLatest } from 'rxjs';
import { Users } from 'src/app/core/resources/user.resource';
import { UsersService } from '../../services/users.service';

@Component({
  selector: 'atm-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss'],
})
export class InformationComponent implements OnChanges {
  @Input() data!: any;

  show = false;
  createUser: Users | null = null;
  updateUser: Users | null = null;

  constructor(private userService: UsersService) {}

  ngOnChanges(): void {
    // this.showInformation();
    if (this.show) {
      combineLatest([
        this.userService.find(this.data.created_by),
        this.userService.find(this.data.updated_by),
      ]).subscribe((ret) => {
        this.createUser = ret[0];
        this.updateUser = ret[1];
      });
    }
  }

  showInformation(): void {
    if (!this.show) {
      combineLatest([
        this.userService.find(this.data.created_by),
        this.userService.find(this.data.updated_by),
      ]).subscribe((ret) => {
        this.show = !this.show;
        this.createUser = ret[0];
        this.updateUser = ret[1];
      });
    } else {
      this.show = false;
    }
  }
}
